export class RequestManager {
    constructor(authKey) {
        this.authKey = authKey
        this.azureURL = "https://www.r1jackal.com/flask/"
        this.localURL = "http://127.0.0.1:5000/flask/"
    }

    async request(endpoint, requestType, body) {
        this.authKey = document.cookie.split("; ").find((row) => row.startsWith("authKey="))?.split("=")[1]

        if (typeof body === "undefined") {
            body = {}
        }

        body["authKey"] = this.authKey
        const currentURL = window.location.href
        const url = (currentURL.includes("localhost")) ? this.localURL : this.azureURL

        console.log("using:", url)

        if (requestType == "POST") {
            return await fetch(url + endpoint, { method: requestType, body: JSON.stringify(body)})
        } else {
            return await fetch(url + endpoint, { method: requestType })
        }
    }
}